export enum AnalyticsEvent {
  PageView = 'page_view',
  ButtonClick = 'button_click',
  EditSessionStarted = 'edit_session_started',
  EditSessionEnded = 'edit_session_ended',
}
